module.exports = __webpack_public_path__ + "img/loading-animation.16bd6b62.svg";